import { ArrowDownToLine } from 'lucide-react';
import React, { useSyncExternalStore } from 'react';

import { applyUpdate, getUpdateStage, onUpdateStageChange } from './app-update-state';

import { isStandaloneApp } from '@/lib/device';

/**
 * Header "Update" chip, next to the bell - only after the user said "Later"
 * to the new-version toast, and only in the installed app. Gone once they
 * update. Icon-only on phones (the header is tight), labelled on wider screens.
 */
export const AppUpdateChip = (): React.JSX.Element | null => {
  const stage = useSyncExternalStore(onUpdateStageChange, getUpdateStage, () => 'none' as const);
  if (stage !== 'deferred' || !isStandaloneApp()) return null;
  return (
    <button
      type="button"
      onClick={() => applyUpdate()}
      aria-label="Update Utazzo"
      title="A new version is ready - tap to update"
      className="relative inline-flex h-8 items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2 text-[13px] font-medium text-emerald-700 hover:bg-emerald-100"
    >
      <ArrowDownToLine className="h-4 w-4" aria-hidden />
      <span className="hidden sm:inline">Update</span>
      <span
        className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-emerald-500 ring-2 ring-[var(--bg)]"
        aria-hidden
      />
    </button>
  );
};
